import{e as l,m as g}from"./chunk-HBP5N4FR.js";function p(e){var s,u;return(u=(s=e==null?void 0:e.results)==null?void 0:s.map(r=>r.returnMessage).filter(r=>Boolean(r)))!=null?u:[]}var t=l(()=>{g()});export{p as a,t as b};
//# sourceMappingURL=chunk-7WXEH6OF.js.map
